<template>
  <div class="headermenu" tabindex="9999" :class="{ disabled: disabled }">
    <b-icon :icon="icon" />
    <span class="hidden-on-small-screens">
      {{ title }}
    </span>
    <div v-if="!disabled">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDownMenu',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    to: {
      type: Object,
      default: function () {
        return { name: '' };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.headermenu div {
  display: none;
}
.headermenu {
  display: inline-block;
  margin-right: 20px;
}

.headermenu:focus {
  outline-style: dotted;
  outline-width: thin;
}

.headermenu:focus div {
  display: block;
  position: absolute;
  top: 1em;
  width: 8ex;
  border: 1px solid;
  background: white;
  color: black;
  padding: 5px;
}

.headermenu div span:hover {
  background: grey;
  width: 100%;
  display: block;
}

.disabled {
  color: grey;
}
.active {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/DropDownMenu.vue